import { useState } from "react";
import { CustomDialog } from "../../../../../../../components/dialog/v1/CustomDialog";
import { useStockCycleDatasValueContextHook } from "../../../../contexts/StockCycleDatasContext";
import { FragmentTable } from "./fragments/fragment-table";
import styled from 'styled-components';
import { CALCULATOR_SERVICE } from "../../service/calculatorService";
import { useSettingVariablesValueContextHook } from "../../../../contexts/SettingVariablesContext";
import { useSheetItemListValueContextHook } from "../../../../contexts/SheetItemListContext";
import { v4 as uuidv4 } from 'uuid';
import _ from "lodash";
import { useSelectedShoppingCartStageValueContextHook } from "../../../../contexts/SelectedShoppingCartStageContext";
import { usePurchaseInfosValueContextHook } from "../../../../contexts/PurchaseInfosContext";
import { FragmentPurchaseList } from "./fragments/fragment-purchase-list";
import CustomBlockButton from "../../../../../../../components/button/CustomBlockButton";
import { customToast } from "../../../../../../../components/toast/custom-react-toastify/v1";
import { useCreateShoppingCartItemsMutation } from "../../../../Data/shoppingCartItemsReactQuery/ShoppingCartItemsReactQuery";
import { useOrderQtyListQuery } from "../../../../Data/orderQtyListReactQuery/OrderQtyListReactQuery";

const StyledPaper = styled.div`
    background-color: var(--backgroundField);
`;

export function ModalViewPurchase({
    open,
    productOptionDetail,
    SAFETY_STOCK_QTY_MULTIPLIER,
    onClose,
}) {
    const stockCycleDatasValueContextHook = useStockCycleDatasValueContextHook();
    const stockCycleDatas = stockCycleDatasValueContextHook.stockCycleDatas;
    const productOptionsDetailList = stockCycleDatas?.productOptionsDetailList;

    const settingVariablesValueContextHook = useSettingVariablesValueContextHook();
    const settingVariables = settingVariablesValueContextHook.settingVariables;

    const sheetItemListValueContextHook = useSheetItemListValueContextHook();
    const sheetItemList = sheetItemListValueContextHook?.sheetItemList;
    const alreadyPurchasedQtyList = CALCULATOR_SERVICE.getAlreadyPurchasedQtyList(sheetItemList);

    const selectedShoppingCartStageValueContextHook = useSelectedShoppingCartStageValueContextHook();
    const selectedShoppingCartStage = selectedShoppingCartStageValueContextHook?.selectedShoppingCartStage;

    const purchaseInfosValueContextHook = usePurchaseInfosValueContextHook();
    const purchaseInfos = purchaseInfosValueContextHook?.purchaseInfos;
    const defaultPurchaseInfoOfProductOptionDetail = purchaseInfos?.find(info => info?.productOptionId === productOptionDetail?.productOptionDto?.id && info?.defaultFlag);

    const createShoppingCartItemsMutation = useCreateShoppingCartItemsMutation();

    const safetyStockQty = productOptionDetail?.iqrData?.releaseQtyPerDay ? (productOptionDetail?.iqrData?.releaseQtyPerDay * SAFETY_STOCK_QTY_MULTIPLIER).toFixed(2) : 0;
    const [purchasedQty, deliveryQty, arrivedQty, documentQty, shippingQty] = alreadyPurchasedQtyList?.map((alreadyPurchasedQty) => {
        let quantity = 0;
        const targetData = alreadyPurchasedQty?.summedArray?.find(r => r.optionCode === productOptionDetail?.productOptionDto?.code);
        if (targetData) {
            quantity = targetData?.quantity;
        }
        return quantity;
    });

    const totalAlreadyPurchasedQty = purchasedQty + deliveryQty + arrivedQty + documentQty + shippingQty;

    const recommendPurchaseQty = CALCULATOR_SERVICE.getRecommendPurchaseQty({
        stockQty: productOptionDetail?.inventoryStockDto?.stockUnit,
        releaseQtyPerDay: productOptionDetail?.iqrData?.releaseQtyPerDay,
        targetDOS: settingVariables.targetDOS,
        daysOfLeadTime: settingVariables.daysOfLeadTime,
        safetyStockQty: safetyStockQty,
        totalAlreadyPurchasedQty: totalAlreadyPurchasedQty,
    });


    const [editableShoppingCartItems, setEditableShoppingCartItems] = useState([{
        uuid: uuidv4(),
        recommendPurchaseQty: recommendPurchaseQty ? recommendPurchaseQty : '0',
        purchaseQty: Math.ceil(recommendPurchaseQty ? recommendPurchaseQty : 0),
        purchaseInfoUuid: defaultPurchaseInfoOfProductOptionDetail ? defaultPurchaseInfoOfProductOptionDetail?.uuid : null,
        purchaseInfo: defaultPurchaseInfoOfProductOptionDetail ? defaultPurchaseInfoOfProductOptionDetail : null,
        stockCycleData: _.cloneDeep(productOptionDetail),
        shoppingCartStageId: null,
    }]);

    const relatedProductOptionsDetailList = productOptionsDetailList?.filter((item) => item.productDto?.id === productOptionDetail.productDto?.id && editableShoppingCartItems?.some(r => r.stockCycleData?.productOptionDto?.id === item.productOptionDto?.id) === false);

    const { data: orderQtyListData, isLoading: orderQtyListDataIsLoading } = useOrderQtyListQuery({
        productOptionIds: [...editableShoppingCartItems?.map(item => item?.stockCycleData?.productOptionDto?.id), ...relatedProductOptionsDetailList?.map(item => item?.productOptionDto?.id)]
    });
    const orderQtyList = orderQtyListData?.data?.content;

    const handleReqAdd = async () => {
        let shoppingCartItemsForm = _.cloneDeep(editableShoppingCartItems);

        try {
            shoppingCartItemsForm.forEach((item, index) => {
                if (!item?.purchaseQty || item?.purchaseQty <= 0) {
                    throw new Error((index + 1) + '행: ' + '구매수량은 0보다 커야합니다.');
                }
                item.shoppingCartStageId = selectedShoppingCartStage?._id;
            })
        } catch (error) {
            customToast.error(error.message);
            return;
        }

        const body = {
            payload: editableShoppingCartItems?.map(item => {
                return {
                    uuid: item.uuid,
                    purchaseQty: item.purchaseQty,
                    shoppingCartStageId: selectedShoppingCartStage?._id,
                    purchaseInfoUuid: item.purchaseInfoUuid,
                    productOptionId: item.stockCycleData.productOptionDto.id,
                    purchaseInfo: item.purchaseInfo,
                    checkedFlag: false,
                }
            })
        }

        createShoppingCartItemsMutation.mutate({
            body: body,
        }, {
            onSuccess: () => {
                onClose();
            }
        })
    }

    return (
        <>
            <CustomDialog
                open={open}
                onClose={onClose}
                maxWidth="xl"
            >
                <StyledPaper>
                    <CustomDialog.Header style={{ padding: 10 }}>
                        <CustomDialog.Header.Fake />
                        <CustomDialog.Header.Title>상품 구매</CustomDialog.Header.Title>
                        <CustomDialog.Header.Close onClick={() => { onClose() }} />
                    </CustomDialog.Header>
                    <FragmentPurchaseList
                        editableShoppingCartItems={editableShoppingCartItems}
                        setEditableShoppingCartItems={setEditableShoppingCartItems}
                        SAFETY_STOCK_QTY_MULTIPLIER={SAFETY_STOCK_QTY_MULTIPLIER}
                        orderQtyList={orderQtyList}
                    />
                    <div
                        className="px-2.5"
                    >
                        <CustomBlockButton
                            type='button'
                            style={{ background: 'var(--primary)', border: '1px solid var(--primary-foreground)', color: 'var(--primary-foreground)', maxWidth: 200, fontWeight: '700', borderRadius: 5, margin: '10px 0 0 auto' }}
                            onClick={() => {
                                handleReqAdd()
                            }}
                        >
                            추가하기
                        </CustomBlockButton>
                    </div>
                    <FragmentTable
                        relatedProductOptionsDetailList={relatedProductOptionsDetailList}
                        setEditableShoppingCartItems={setEditableShoppingCartItems}
                        SAFETY_STOCK_QTY_MULTIPLIER={SAFETY_STOCK_QTY_MULTIPLIER}
                        selectedShoppingCartStage={selectedShoppingCartStage}
                        purchaseInfos={purchaseInfos}
                        orderQtyList={orderQtyList}
                    />
                </StyledPaper>
            </CustomDialog>
        </>
    );
}